import { render, staticRenderFns } from "./ManageHeader.vue?vue&type=template&id=6c33e689&scoped=true"
import script from "./ManageHeader.vue?vue&type=script&lang=js"
export * from "./ManageHeader.vue?vue&type=script&lang=js"
import style0 from "./ManageHeader.vue?vue&type=style&index=0&id=6c33e689&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c33e689",
  null
  
)

export default component.exports